import NotificationProduced from '../../application/core/events/NotificationProduced';
import EstimationsDraftSaveRequested from '../../application/estimations/events/EstimationsDraftSaveRequested';
import * as uniqid from 'uniqid';
import State from '../../application/core/State';
import Event from '../../application/core/Event';
import Notification from '../../application/core/Notification';
import containsAtLeastOneNotSavedEstimation from './containsAtLeastOneNotSavedEstimation';

export default (state: State, event: EstimationsDraftSaveRequested): Event[] =>
    containsAtLeastOneNotSavedEstimation(state.estimations.estimations, state.estimations.placedEstimations)
        ? [event]
        : [
              new NotificationProduced(
                  new Notification(uniqid(), {
                      message: 'Please, provide/update quantity for at least one item before placing estimation.',
                      hasButton: true
                  })
              )
          ];



// WEBPACK FOOTER //
// ./src/domain/estimations/validatePlaceEstimation.ts